<ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-graph-modal'">
  <div class="modal-header" xmlns:svg="http://www.w3.org/1999/XSL/Transform" ngxModalDraggable>
    <h4 class="modal-title pull-left">{{title}}</h4>
    <div class="ms-auto">
      <a ngbDropdown container="body" class="me-2">
        <button ngbDropdownToggle class="btn btn-outline-primary dropdown-toggle"
                type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{t('Export as')}}
        </button>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <a ngbDropdownItem class="dropdown-item" (click)="exportAs('SVG')">{{t('SVG')}}</a>
          <a ngbDropdownItem class="dropdown-item" (click)="exportAs('PNG')">{{t('PNG')}}</a>
        </div>
      </a>
      <button type="button" class="btn btn-outline-primary" (click)="showGraphOptions()">
        <span aria-hidden="true">Options</span>
      </button>
    </div>
    <button type="button" class="btn-close ms-2" aria-label="Close" (click)="bsModalRef.dismiss()">
    </button>
  </div>
  <div class="modal-body" *ngIf="graph()?.Nodes" style="height: calc(100vh - 70px); overflow: hidden">
    <div class="chart-area">
      <ngx-graph id="graph-container-{{id}}"
                 class="chart-container"
                 [links]="graph().Links" [curve]="curve" [layout]="layout" [enableZoom]="true" [autoCenter]="true" [autoZoom]="true" [panOnZoom]="true"
                 [nodes]="graph().Nodes" [layoutSettings]="{orientation: orientation || 'LR'}"
                 [update$]="update$">

        <ng-template #defsTemplate>
          <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4" orient="auto">
            <svg:path d="M0,-5L10,0L0,5" class="arrow-head"/>
          </svg:marker>
        </ng-template>

        <ng-template #nodeTemplate let-node>
          <svg:g class="node" [ngbPopover]="nodeTooltipTemplate" #popover="ngbPopover" triggers="manual" [autoClose]="'outside'" (click)="togglePopover(popover, node)" container="body">
            <svg:rect [attr.width]="node.dimension.width" [attr.height]="node.dimension.height" [attr.rx]="4" [attr.ry]="4"
                      [attr.fill]="node.Color" [attr.stroke]="node.StrokeColor" [attr.stroke-width]="node.StrokeWidth"/>
            <svg:text [attr.width]="node.dimension.width" [attr.height]="node.dimension.height" [attr.x]="10" [attr.y]="node.dimension.height / 2"
                      [attr.fill]="node.TextColor" alignment-baseline="central">
              {{node | nodeLabel}}
            </svg:text>
          </svg:g>
        </ng-template>

        <ng-template #linkTemplate let-link>
          <svg:g class="edge" [ngbPopover]="linkTooltipTemplate" #linkPopover="ngbPopover" triggers="manual" [autoClose]="'outside'" (click)="togglePopover(linkPopover, null, link)" container="body">
            <svg:path class="line" stroke-width="2" marker-end="url(#arrow)">
            </svg:path>
            <svg:text class="edge-label" text-anchor="middle">
              <textPath class="text-path" [attr.href]="'#' + link.id" [style.dominant-baseline]="link.dominantBaseline" startOffset="50%">
                {{link.label}}
              </textPath>
            </svg:text>
          </svg:g>
        </ng-template>

      </ngx-graph>
    </div>
  </div>

  <ng-template #nodeTooltipTemplate let-node="node" let-close="close">
    <ul class="list-unstyled" *ngIf="node.Data">
      <li *ngIf="node.type === 3 || node.isMaterialNode()" class="fw-bold">
        {{(itemService.getAll$ | async | find: 'Id' : node.entityId)?.DisplayName}}
      </li>
      <li *ngIf="node.isMasterInputInstructionNode() || node.isMasterOutputInstructionNode()">
        <em>{{t('Yield')}}</em>: {{node.Data.YieldRate}}
      </li>
      <li *ngIf="node.isMasterInputInstructionNode() || node.isMasterOutputInstructionNode()">
        <em>{{t('Production Ratio')}}</em>: {{node.Data.ProductionRatio}}
      </li>
      <li *ngIf="node.isMasterUseInstructionNode()">
        <em>{{t('Production Duration')}}</em>: {{node.Data.Production}}
      </li>
      <li *ngIf="node.isProcessSelectorNode()">
        <em>{{t('Valid condition')}}</em>: {{node.Data.ValidCondition.Formula}}
      </li>
      <li *ngFor="let spec of node.Data.Specs | keyvalue">
        <ng-container *ngIf="(propertiesQuery.selectEntity(spec.key) | async) as p">
          <em>{{p?.Name}}</em>:
          <span *ngIf="p.isHtml()" [innerHTML]="spec.value | safe: 'html'"></span>
          <ng-container *ngIf="!p.isHtml()">
            {{spec.value}}
          </ng-container>
        </ng-container>
      </li>
    </ul>
    <div class="d-flex">
      <button type="button" *ngIf="(node.isItemNode() || node.isItemGroupNode()) && node.entityId !== graph().Id" class="btn btn-outline-primary btn-sm me-auto" (click)="openGraph(node); close()">
        <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#fork'">
        </svg>
        {{t('Graph')}}
      </button>
      <button type="button" *ngIf="node.isProcessSelectorNode()" class="btn btn-outline-primary btn-sm me-auto" (click)="toggleBranch(node); close()">
        <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#arrows-pointing-out'">
        </svg>
        {{t('Toggle visibility')}}
      </button>
      <button type="button" class="btn btn-outline-primary btn-sm ms-auto" (click)="viewObjectUnderNode(node); close()">
        <svg viewBox="0 0 8 8" class="icon small" [inlineSVG]="'#arrow-top-right-on-square'">
        </svg>
        {{t('View')}}
      </button>
    </div>
  </ng-template>

  <ng-template #linkTooltipTemplate let-link="link">
    <ul class="list-unstyled">
      <li>
        {{link.label}}
      </li>
    </ul>
  </ng-template>
</ng-container>

